"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PassportScoreTree = void 0;
var ethers_1 = require("ethers");
var MerkleTree_1 = __importDefault(require("./MerkleTree"));
var PassportScoreTree = /** @class */ (function () {
    function PassportScoreTree(creditScores) {
        this.ensureUniqueAccounts(creditScores);
        this.tree = new MerkleTree_1.default(creditScores.map(PassportScoreTree.toNode));
    }
    PassportScoreTree.verifyProof = function (score, proof, root) {
        var pair = PassportScoreTree.toNode(score);
        for (var _i = 0, proof_1 = proof; _i < proof_1.length; _i++) {
            var item = proof_1[_i];
            pair = MerkleTree_1.default.combinedHash(pair, item);
        }
        return pair === root;
    };
    PassportScoreTree.toNode = function (score) {
        return ethers_1.utils.solidityKeccak256(['address', 'bytes32', 'uint256'], [score.account, score.protocol, score.score]);
    };
    PassportScoreTree.prototype.getHexRoot = function () {
        return this.tree.getHexRoot();
    };
    PassportScoreTree.prototype.getProof = function (score) {
        return this.tree.getProof(PassportScoreTree.toNode(score));
    };
    /**
     * Ensure an account does not have multiple scores for the same protocol
     */
    PassportScoreTree.prototype.ensureUniqueAccounts = function (passportScores) {
        var uniqueMap = {};
        for (var _i = 0, passportScores_1 = passportScores; _i < passportScores_1.length; _i++) {
            var score = passportScores_1[_i];
            var key = score.account + "-" + score.protocol;
            if (!uniqueMap[key]) {
                uniqueMap[key] = key; // Value never used
            }
            else {
                throw Error("There are more than 1 score for the protocol " + ethers_1.utils.parseBytes32String(score.protocol) + " for user " + score.account);
            }
        }
    };
    return PassportScoreTree;
}());
exports.PassportScoreTree = PassportScoreTree;
